import { useEffect, useMemo, useState } from "react";
import { useNavigate } from "react-router-dom";
import ActionButtonDropdown from "../../../../Components/ActionButtonDropdown";
import Pagination from "../../../../Core/Pagination/Pagination";
import ListLayout from "../../../../Core/Layout/ListLayout";
import Tabs from "../../../../Components/Tabs";
import ConfigureColumns from "./ConfigureColumns";
import ReportTable from "../../../../Core/ReportTable/ReportTable";
import ReportSearchFilter from "../../../../Core/ReportSearchFilter/ReportSearchFilter";
import { useGetFrappeReportQuery, useGetWarehousesQuery, useGetDynamicResourceQuery } from '../../../../store/api/reportApi';
import { usePostItemListMutation } from "../../../../store/api/purchaseorderapi";
import { useGetCompanyQuery } from '../../../../store/api/companyapi'

const Lpntable = () => {
    const navigate = useNavigate();
    const pageSize = 11;
    const [currentPage, setCurrentPage] = useState(1);
    const [showColumnConfig, setShowColumnConfig] = useState(false);
    const [item_list, setitem_list] = useState([]);
    const [getitem_list_data] = usePostItemListMutation();
    const [warehouseSearchTerm, setWarehouseSearchTerm] = useState('');
    const [itemGroupSearchTerm, setItemGroupSearchTerm] = useState('');
    const [batchSearchTerm, setBatchSearchTerm] = useState('');
    const [brandSearchTerm, setBrandSearchTerm] = useState('');
    const [projectSearchTerm, setProjectSearchTerm] = useState('');
    const [umoSearchTerm, setUmoSearchTerm] = useState('');

    const {
        data: companyData,
        error: companyError,
        isLoading: companyLoading,
        refetch: companyRefetch
    } = useGetCompanyQuery();
    const {
        data: warehouseData,
        isLoading: isWarehouseLoading,
        refetch: refetchWarehouses,
    } = useGetWarehousesQuery({ searchTerm: warehouseSearchTerm });

    const {
        data: itemGroupsData,
        isLoading: itemGroupsLoading,
    } = useGetDynamicResourceQuery({
        resource: "Item Group",
        searchTerm: itemGroupSearchTerm,
        fields: ["name"]
    });
    const {
        data: batchData,
        isLoading: batchLoading,
    } = useGetDynamicResourceQuery({
        resource: "Batch",
        searchTerm: batchSearchTerm,
        fields: ["name"]
    });

    const {
        data: brandData,
        isLoading: brandLoading,
    } = useGetDynamicResourceQuery({
        resource: "Brand",
        searchTerm: brandSearchTerm,
        fields: ["name"]
    });
    const {
        data: projectData,
        isLoading: projectLoading,
    } = useGetDynamicResourceQuery({
        resource: "Project",
        searchTerm: projectSearchTerm,
        fields: ["name"]
    });
    const {
        data: umoData,
        isLoading: umoLoading,
    } = useGetDynamicResourceQuery({
        resource: "UMO",
        searchTerm: umoSearchTerm,
        fields: ["name"]
    });



    console.log(itemGroupsData, "itemGroupsData");

    console.log(warehouseData, "warehouseData");


    const getItemdata = async (newOffset = 0, searchText = "") => {
        const res = await getitem_list_data({ start: newOffset, search_input: searchText });
        const products = res?.data?.result?.products || [];
        if (newOffset === 0) {
            setitem_list(products);
        } else {
            setitem_list((prev) => [...prev, ...products]);
        }
    };

    useEffect(() => {
        getItemdata();
    }, []);
    const itemOptions = item_list.map(item => ({
        value: item.item_code,
        label: item.item_name,
    }));
    const warehouseOptions = warehouseData?.data?.map(warehouse => ({
        value: warehouse.name,
        label: warehouse.name,
    })) || [];
    const itemGroupOptions = itemGroupsData?.data?.map(group => ({
        value: group.name,
        label: group.name,
    })) || [];
    const batchOptions = batchData?.data?.map(batch => ({
        value: batch.name,
        label: batch.name,
    })) || [];
    const brandOptions = brandData?.data?.map(brand => ({
        value: brand.name,
        label: brand.name,
    })) || [];
    const projectOptions = projectData?.data?.map(project => ({
        value: project.name,
        label: project.name,
    })) || [];
    const umoOptions = umoData?.data?.map(umo => ({
        value: umo.name,
        label: umo.name,
    })) || [];
const companyOptions = companyData?.result?.map(company => ({
  value: company.name,     
  label: company.company_name || company.name,
})) || [];



    // Initialize filters state with default values
    const getDefaultDate = (daysOffset = 0) => {
        const date = new Date();
        date.setDate(date.getDate() + daysOffset);
        return date.toISOString().split('T')[0];
    };

    const [currentFilters, setCurrentFilters] = useState({
        company: 'Stackerbee',
        from_date: getDefaultDate(-30),
        to_date: getDefaultDate(0),
    });

    const getCleanedFilters = () => {
        const cleaned = { ...currentFilters };

        // Remove empty string values
        Object.keys(cleaned).forEach(key => {
            if (cleaned[key] === '') {
                delete cleaned[key];
            }
        });

        // Always include pagination parameters
        cleaned.start = (currentPage - 1) * pageSize;
        cleaned.page_length = pageSize;

        return cleaned;
    };

    // Use the RTK Query hook with cleaned filters
    const { data, error, isLoading, refetch } = useGetFrappeReportQuery({
        report_name: 'Stock Ledger',
        filters: getCleanedFilters()
    });

    const handleSaveColumns = (updatedColumns) => {
        setShowColumnConfig(false);
    };
console.log(data,"data_new");

    const filtersConfig = [
          {
            name: 'company',
            label: 'company',
            width: '17%',
            type: 'selectsearch',
            options: companyOptions,
            defaultValue: 'Stackerbee'
        },
        // { name: 'company', label: 'Company', width: '17%', defaultValue: 'Stackerbee' },
        { name: 'from_date', label: 'From Date', type: 'date', width: '11.7%', defaultValue: getDefaultDate(-30) },
        { name: 'to_date', label: 'To Date', type: 'date', width: '11.7%', defaultValue: getDefaultDate(0) },
        {
            name: 'item_code',
            label: 'Item',
            width: '14%',
            type: 'selectsearch',
            options: itemOptions
        },
        {
            name: 'item_group',
            label: 'Item Group',
            width: '14%',
            type: 'selectsearch',
            options: itemGroupOptions
        },
        {
            name: 'warehouse',
            label: 'Warehouse',
            width: '14%',
            type: 'selectsearch',
            options: warehouseOptions
        },
        {
            name: 'batch_no',
            label: 'Batch Number',
            width: '14%',
            type: 'selectsearch',
            options: batchOptions
        },
        {
            name: 'brand',
            label: 'Brand',
            width: '20%',
            type: 'selectsearch',
            options: brandOptions
        },
        { name: 'voucher', label: 'Voucher', width: '15%' },
        {
            name: 'project',
            label: 'Project',
            width: '20%',
            type: 'selectsearch',
            options: projectOptions
        },
        {
            name: 'include_uom',
            label: 'UOM',
            width: '12.7%',
            type: 'selectsearch',
            options: umoOptions 
        },
                {
            name: 'Currency',
            label: 'currency',
            width: '11.7%',
            type: 'select',
            options: [
                { value: 'currency', label: 'Currency' },
                { value: 'float', label: 'Float' },

            ]
        },
                {
            name: 'segregate_serial_batch_bundle',
            label: 'Segregate Serial Batch Bundle',
            width: '15%',
            type: 'checkbox',
            defaultValue: 0
        }

    ];

    const handleFilterNewChange = (newFilters) => {
        setCurrentFilters(prev => ({
            ...prev,
            ...newFilters
        }));
        setCurrentPage(1);
    };

    const handleSearchChange = (name, value) => {
        console.log(`Search in ${name}:`, value);
        if (name === "item_code") {
            getItemdata(0, value);
        }
           if (name === "item_group") {
            setItemGroupSearchTerm(value);
        }
        if (name === "warehouse") {
            setWarehouseSearchTerm(value);
        }
     
        if (name === "batch_no") {
            setBatchSearchTerm(value);
        }
        if (name === "brand") {
            setBrandSearchTerm(value);
        }
        if (name === "project") {
            setProjectSearchTerm(value);
        }

        if (name === "umo") {
            setUmoSearchTerm(value);
        }
    };

    const handleView = (id) => {
        navigate(`/outbound/outbound-sales-order-view/`, { state: { salesorder: id } });
    };

    const handleEdit = (id) => {
        navigate(`/outbound/outbound-sales-order-edit/`, { state: { salesorder: id } });
    };

    const handleDelete = (id) => {
        console.log("Delete logic for ID:", id);
    };

    const getColumnWidth = (fieldname) => {
        switch (fieldname) {
            case 'date': return '200px';
            case 'updated_at': return '200px';
            case 'in_qty': return '70px';
            case 'out_qty': return '70px';
            case 'qty_on_pick': return '150px';
            case 'reserved_qty': return '170px';
            case 'category': return '140px';
            case 'name':
            case 'title': return '180px';
            default: return '150px';
        }
    };

    const isSortable = (fieldname) => {
        console.log(fieldname, "fieldname_test");
        const sortableFields = [
            'created_at',
            'updated_at',
            'price',
            'amount',
            'total',
            'status',
            'id',
            'name',
            'date',
            'item_code',
            'item_name',
            'stock_uom',
            'in_qty',
            'out_qty',
            'qty_on_pick',
            'reserved_qty',
            'reverse_pick',
            'picked_qty',
            'available_qty',
            'qty_after_transaction',
            'voucher_no',
            'warehouse',
            'item_group',
            'brand',
            'description',
            'incoming_rate',
            'valuation_rate',
            'stock_value',
            'stock_value_difference',
            'type_of_transaction',
            'voucher_type',
            'batch_no',
            'serial_no',
            'balance_serial_no',
            'project',
            'company'
        ];
        return sortableFields.includes(fieldname);
    };

    const getSortFn = (fieldtype, fieldname) => {
        if (fieldtype === 'Datetime') {
            return (a, b) => new Date(a[fieldname]) - new Date(b[fieldname]);
        }
        if (['Float', 'Currency', 'Int'].includes(fieldtype)) {
            return (a, b) => parseFloat(a[fieldname]) - parseFloat(b[fieldname]);
        }
        return undefined;
    };

    const excludedFields = [
        'batch_no',
        'serial_no',
        'balance_serial_no',
        'project',
    ];
    const preferredOrder = [
        'warehouse', 'item_code', 'item_name'
    ];

const dynamicColumns = useMemo(() => {
  if (!data?.message?.columns) return [];

  const sortedColumns = [...data.message.columns]
    .filter(col => !excludedFields.includes(col.fieldname))
    .sort((a, b) => {
      const indexA = preferredOrder.indexOf(a.fieldname);
      const indexB = preferredOrder.indexOf(b.fieldname);

      if (indexA === -1 && indexB === -1) return 0;
      if (indexA === -1) return 1;
      if (indexB === -1) return -1;
      return indexA - indexB;
    });

  const baseColumns = sortedColumns.map(col => ({
    header: col.label,
    name: col.fieldname,
    accessor: col.fieldname,
    width: getColumnWidth(col.fieldname),
    sortable: isSortable(col.fieldname),
    sortFn: getSortFn(col.fieldtype, col.fieldname),
    fieldtype: col.fieldtype,
    options: col.options
  }));

  // Add SI No column at the start
  const siNoColumn = {
    header: 'SI No',
    name: 'si_no',
    width: '60px',
    sortable: false,
    // Render serial number based on row index
    cellRenderer: (row, rowIndex) => rowIndex + 1,
  };

  return [siNoColumn, ...baseColumns];

}, [data, currentPage]);

    const actionButtons = [
        {
            className: "createbtn border-0 d-flex",
            style: { gap: '2px', height: '28px' },
            iconName: "RiFileExcel2Fill",
            iconSize: 12,
            children: "Export Excel"
        }
    ];

    return (
        <div className="container-fluid mt-3">
            <Tabs />
            <ListLayout
                breadcrumbItems={[
                    { label: "Report" },
                    
                                        { label: "Ledger" },

                    { label: "Stock Ledger List",style:{color:'#270B79'} }
                ]}
                actionButtons={actionButtons}
            >
                <ReportSearchFilter
                    filtersConfig={filtersConfig}
                    onFilterChange={handleFilterNewChange}
                    onSearchChange={handleSearchChange}
                />

                <ReportTable
                    columns={dynamicColumns}
                    data={data?.message.result || data?.result || []}
                    loading={isLoading}


                    pageSize={pageSize}
                    totalRecords={data?.message?.total} 
                    currentPage={currentPage}
                    onPageChange={setCurrentPage}
                    showPagination={true}
                />


            </ListLayout>

            <ConfigureColumns
                show={showColumnConfig}
                onClose={() => setShowColumnConfig(false)}
                onSave={handleSaveColumns}
                initialFields={dynamicColumns}
            />
        </div>
    );
};

export default Lpntable;